export default __webpack_public_path__ + "static/media/bg.ef4dcf6c.png";